import { Bookmark } from '../types';
import { createTestFactory } from './factory';

export const getDummyBookmark = createTestFactory<Bookmark>({
  id: 'bookmark-1',
  url: 'https://example.com',
  title: 'Example',
  description: 'A test bookmark',
  userId: 'user-1',
  createdAt: new Date(),
  updatedAt: new Date(),
});
